import store from '../store'
import router from '../router'
import checkoutConfigService from './checkoutConfig'

class RouterService {
  _steps = [
    {
      stepNumber: 1,
      url: 'contact_information'
    },
    {
      stepNumber: 2,
      url: 'shipping_methods'
    },
    {
      stepNumber: 3,
      url: 'payment_methods'
    },
    {
      stepNumber: 10,
      url: 'Order'
    }
  ]
  goTo (uri) {
    router.push(uri)
      .then(() => {
      })
      .catch(err => {
        console.log(err)
      })
  }

  getStepObj (query, key) {
    return this._steps.filter((step) => {
      return step[key] === query
    })[0]
  }

  getActiveStep () {
    const _store = store
    if (_store.getters.Checkout) {
      return this.getStepObj(_store.getters.currentStep, 'stepNumber')
    }
    return false
  }

  async goToNextStep () {
    const _store = store
    let nextStep = _store.getters.currentStep < 3 ? _store.getters.currentStep + 1 : 10
    _store.dispatch('SetCheckoutStep', nextStep)
  }

  async goToPrevStep () {
    const _store = store
    let prevStep = _store.getters.currentStep - 1
    console.log('Prev: ', prevStep)
    _store.dispatch('SetCheckoutStep', prevStep)
  }
  async goToStep (step) {
    const _store = store
    let stepURL = this.getStepObj(step, 'stepNumber').url
    const isReserveInactive = checkoutConfigService.isReserveActive() === false
    const paymentMethod = _store.getters.Checkout.payment_info.type
    const hasNoOrder = !_store.getters.Checkout.order.number
    const noteAttributes = _store.getters.Checkout.note_attributes
    if (_store.getters.Checkout.closed && (paymentMethod === 'ORDER_RESERVE' || this.HasReserveAttribute(noteAttributes)) && isReserveInactive && hasNoOrder) {
      stepURL = this.getStepObj(3, 'stepNumber').url
    }
    if (stepURL === 'Order') {
      this.goTo('/Order/' + _store.getters.Checkout.id)
    } else if (_store.getters.Checkout) {
      this.goTo('/Checkout/' + _store.getters.Checkout.id + '/' + stepURL)
    }
  }

  HasReserveAttribute(noteAttributes) {
    if (!noteAttributes || noteAttributes.length === 0) {
      return false
    }

    for (var i = 0; i < noteAttributes.length; i++) {
      if (noteAttributes[i].name === 'checkout_reserve') {
        return true
      }
    }

    return false
  }
}
export default new RouterService()
